import React from "react";
import {Card, CardBody} from "../../../../_metronic/_partials/controls";

export function StatisticsForSalesContainer() {

  return (
    <Card className="flex-grow-1">
      <CardBody>
        StatisticsForSalesContainer
      </CardBody>
    </Card>
  );
}

